import { render, staticRenderFns } from "./CardBusinessArea.vue?vue&type=template&id=6e451012&"
import script from "./CardBusinessArea.vue?vue&type=script&lang=js&"
export * from "./CardBusinessArea.vue?vue&type=script&lang=js&"
import style0 from "./CardBusinessArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports